import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";

import TopNav from "./components/TopNav";
import Footer from "./components/Footer";
import MobileBottomNav from "./components/MobileBottomNav";

import ShopHome from "./pages/ShopHome";
import CategoryPage from "./pages/CategoryPage";
import BrandPage from "./pages/BrandPage";
import SearchPage from "./pages/SearchPage";
import VoucherDetail from "./pages/VoucherDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";

import AccountShell from "./pages/account/AccountShell";
import AccountOverview from "./pages/account/AccountOverview";
import WalletPage from "./pages/WalletPage";
import ScanPage from "./pages/ScanPage";
import AccountVouchers from "./pages/account/AccountVouchers";
import AccountBills from "./pages/account/AccountBills";
import AccountProfile from "./pages/account/AccountProfile";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminShell from "./pages/admin/AdminShell";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBills from "./pages/admin/AdminBills";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminRewards from "./pages/admin/AdminRewards";
import AdminBrands from "./pages/admin/AdminBrands";
import AdminLoyaltyRules from "./pages/admin/AdminLoyaltyRules";
import AdminRedemptions from "./pages/admin/AdminRedemptions";

function PublicLayout({ children }) {
    const loc = useLocation();
    const hideChrome = /^\/(admin|login)/.test(loc.pathname);
    return (
        <>
            {!hideChrome && <TopNav />}
            <div className={!hideChrome ? "pb-24 lg:pb-12" : ""}>{children}</div>
            {!hideChrome && <Footer />}
            {!hideChrome && <MobileBottomNav />}
        </>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <CartProvider>
                <BrowserRouter>
                    <PublicLayout>
                        <Routes>
                            <Route path="/" element={<ShopHome />} />
                            <Route path="/category/:name" element={<CategoryPage />} />
                            <Route path="/brand/:slug" element={<BrandPage />} />
                            <Route path="/search" element={<SearchPage />} />
                            <Route path="/voucher/:id" element={<VoucherDetail />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/login" element={<Login />} />

                            <Route path="/account" element={<AccountShell />}>
                                <Route index element={<AccountOverview />} />
                                <Route path="wallet" element={<WalletPage />} />
                                <Route path="scan" element={<ScanPage />} />
                                <Route path="vouchers" element={<AccountVouchers />} />
                                <Route path="bills" element={<AccountBills />} />
                                <Route path="profile" element={<AccountProfile />} />
                            </Route>

                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminShell />}>
                                <Route index element={<AdminDashboard />} />
                                <Route path="bills" element={<AdminBills />} />
                                <Route path="customers" element={<AdminCustomers />} />
                                <Route path="brands" element={<AdminBrands />} />
                                <Route path="rewards" element={<AdminRewards />} />
                                <Route path="loyalty-rules" element={<AdminLoyaltyRules />} />
                                <Route path="redemptions" element={<AdminRedemptions />} />
                            </Route>

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </PublicLayout>
                </BrowserRouter>
            </CartProvider>
        </AuthProvider>
    );
}
